import { render, staticRenderFns } from "./ArticlesByTags.vue?vue&type=template&id=80a8c7e2"
import script from "./ArticlesByTags.vue?vue&type=script&lang=js"
export * from "./ArticlesByTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports